import { FILE_DATA_GSTR8, LOADER_STATUS} from "./constants";

export const initialState = {
  loaderStatus: false,
  fileTableData:[]
  
};

const gstr8FileDataReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
        case FILE_DATA_GSTR8:
          return {
            ...state,
            fileTableData:action.fileTableData
          } 
        
      default:
        return state; 
    }
  };

export default gstr8FileDataReducer;
